export const environment = {
  endPoint: 'https://dev.octopiwellness.com/api/',
};
